import React from 'react';

export interface Heading3Props {
    title: string; // Array of image URLs
}

export const Heading3: React.FC<Heading3Props> = (props) => {
    const { title } = props;

    return (
        <div className='text-gray-950 text-lg font-semibold mb-3 text-left'>
            {title}
        </div>
    );
};